import { NOTIFICATION_TYPE } from '../../../../constants/common'
import i18n from '../../../../i18n'
import { DocFlowMappingProcessCell } from '../../DocFlowMapping'

export function getDocFlowMappingTypeWidgetProgress(processData) {
  return Math.floor(
    processData?.[DocFlowMappingProcessCell.AwsProcessPercent] || 0
  )
}

export function getDocFlowMappingTypeWidgetNotifications({
  isMultiplyingDone,
  processData,
  typeInProcess,
}) {
  switch (true) {
    case isMultiplyingDone:
      return {
        text: i18n.t(
          'DocumentStapling.SplittingPhaseMultiplyingTypeSuccessNotificationKey'
        ),
        type: NOTIFICATION_TYPE.success,
      }

    case typeInProcess:
      return {
        text: i18n.t(
          'DocumentStapling.SplittingPhaseTypeWidgetProcessNotificationKey',
          {
            count: getDocFlowMappingTypeWidgetProgress(processData),
          }
        ),
        type: NOTIFICATION_TYPE.info,
      }

    default:
      return null
  }
}
